export const POSITION_STOP_ORDERS = 'position-stop-orders';
export const PORTFOLIO_PAGE = 'portfolio-page';
export const ORDER_STOP_ORDERS = 'order-stop-orders';
export const PRO_ORDERS = 'pro-orders';
export const DEPOSITS_ENABLED = 'deposits-enabled';
export const WITHDRAWS_ENABLED = 'withdraws-enabled';
export const SUBACCOUNT_PICKER = 'subaccount-picker';

export const allFlags = [
  POSITION_STOP_ORDERS,
  PORTFOLIO_PAGE,
  ORDER_STOP_ORDERS,
  PRO_ORDERS,
  WITHDRAWS_ENABLED,
  DEPOSITS_ENABLED,
  SUBACCOUNT_PICKER,
] as const;
